import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" }));
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
